{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Se alle alternativer",
  "Spoiler_Reveal_Tooltip": "Klikk for å avsløre",
  "VerticalEmbed_Event_Error_Subtitle": "Dette arrangementet er slettet, og erstatt det med et annet.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet dette",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element er skjult",
  "Spoiler_Reveal_Video_CTA": "Avslør video",
  "VerticalEmbed_Pricing_Plan": "Kun pakke",
  "Image_Expand_Button_AriaLabel": "Utvid bildet",
  "VerticalEmbed_From_Price": "Fra",
  "Poll_Viewer_ShowAllResults_CTA": "Se alle resultater",
  "Spoiler_Reveal_Image_Placeholder": "Dette bildet inneholder en spoiler",
  "VerticalEmbed_Ribbon": "Salg",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Glidebryter for søk",
  "VerticalEmbed_Error_Subtitle": "Dette elementet er slettet, erstatt det med et annet.",
  "Poll_Viewer_Multiselect_Footer": "Du kan stemme på mer enn ett svar.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Vis flere lydkontroller",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Tjenesten kunne ikke lastes inn",
  "Fullscreen_Close_Button_AriaLabel": "Lukk",
  "VerticalEmbed_Event_Fetch_Error_Title": "Arrangementet kunne ikke lastes inn",
  "UploadFile_Viewer_Loader": "Laster inn {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Brukeravatar",
  "Preview_ReadMore_Label": "Les mer",
  "Spoiler_Insert_Tooltip": "Sensurfilter",
  "VerticalEmbed_Product_Fetch_Error_Title": "Produktet kunne ikke lastes inn",
  "Fullscreen_Shrink_Button_AriaLabel": "Krymp",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volum",
  "Spoiler_Reveal_Gallery_Placeholder": "Dette galleriet inneholder en spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Utvid",
  "VerticalEmbed_Bookings_Button": "Book nå",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Opphev demping",
  "Spoiler_Reveal_Gallery_CTA": "Avslør galleri",
  "Poll_Viewer_ShowLess_CTA": "Vis mindre",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Demp",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonyme",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Følg",
  "VerticalEmbed_Products_Button": "Kjøp nå",
  "Poll_Viewer_Toast_Error_ServerDown": "Kunne ikke koble til server. Prøv igjen senere.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person stemte på dette svaret",
  "Poll_Viewer_VoteCount": "{{number}} stemmer",
  "VerticalEmbed_Events_Button": "Registrer deg nå",
  "Spoiler_Reveal_Image_CTA": "Avslør bilde",
  "Poll_Viewer_Toast_Error_Connection": "Ikke noe internett. Sjekk tilkoblingen din.",
  "Poll_Viewer_Visibility_Owner_Footer": "Kun du kan se resultatene.",
  "VerticalEmbed_Booking_Error_Title": "Tjeneste slettet",
  "VerticalEmbed_Product_Error_Title": "Produkt slettet",
  "VerticalEmbed_Fetch_Error_Subtitle": "Kan ikke laste inn vareinformasjon.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personer stemte på dette svaret",
  "VerticalEmbed_Event_Error_Title": "Arrangementet er slettet.",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element er utvidet",
  "Audio_Plugin_Cover_Alt": "Lyddeksel",
  "Spoiler_Reveal_Video_Placeholder": "Denne videoen inneholder en spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Det oppstod et teknisk problem. Sjekk tilkoblingen og prøv igjen.",
  "VerticalEmbed_Fetch_Error_Title": "Kunne ikke laste inn elementet",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Dette produktet er slettet, erstatt det med et annet produkt.",
  "VerticalEmbed_Booking_Error_Subtitle": "Denne tjenesten er slettet, og erstatt den med en annen tjeneste.",
  "Preview_SeeFullPost_Label": "Se hele innlegget",
  "UploadFile_Viewer_Download": "Last ned {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}t",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Det oppstod et teknisk problem. Sjekk tilkoblingen og prøv igjen.",
  "VerticalEmbed_Error_Button": "Erstatt",
  "VerticalEmbed_Error_Title": "Elementet er slettet",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Det oppstod et teknisk problem. Sjekk tilkoblingen og prøv igjen.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
